import React, { useContext, useEffect, useState } from "react";
import {
  IAddUpdateAgentManagementPageProps,
  IAddUpdateAgentManagementPageState,
  IAgentTitle,
  IBrandsResponseObject,
  IIdValuePairResponse,
  ISelectedBrand,
  IZonesResponseObject,
} from "../../../interfaces/Index";
import backArrowIcon from "../../../assets/images/back_arrow.svg";
import FormSectionLayout from "../../layouts/FormSectionLayout";
import TextField from "../../common/TextField/TextField";
import ButtonComponent from "../../common/Button/ButtonComponent";
import { Col, Container, Form, Row } from "reactstrap";
import "./AddUpdateAgentManagementPage.scss";
import {
  alphaNumericValidator,
  cnicNumberOnlyValidator,
  cnicNumberValidate,
  numbersOnly,
  phoneNumberOnlyValidator,
  phoneNumberValidate,
} from "../../../utils/Validators";
import Toaster from "../../common/Toaster/Toaster";
import LoaderComponent from "../../common/Loader/Loader";
import HeadingText from "../../common/HeadingText/HeadingText";
import {
  normalizeAgentManagementUserCreatePayload,
  normalizeAgentManagementUserUpdatePayload,
  normalizeCreateAgentOnlyPayload,
} from "../../../normalizer/AgentManagementNormalizer";
import MultiSelectDropDown from "../../common/MultiSelectDropDown/MultiSelectDropDown";
import DropdownButton from "../../common/ButtonDropDown/ButtonDropDown";
import { AbilityContext } from "../../../config/Can";
import { access } from "../../../config/constants";
import SearchableSelect from "../../common/SearchableSelect/SearchableSelect";
import { autoGeneratePassword } from "../../../utils/lib";
import { updateUserPasswordApiCall } from "redux/sources/CustomerSource";
import Modal from "components/common/Modal/Modal";
import { doUserAPIsearch } from "../customer/AddUpdateCustomerPage";
import LoggingViewer from "components/common/LoggingViewer/LoggingViewer";
import { PRIME_AGENT } from "./constants/AgentManagementConstants";

export const autoGeneratePass = autoGeneratePassword();

export const copyPassword = (e: any, setShowPassword: any) => {
  if (e) {
    navigator.clipboard.writeText(e);
    setShowPassword(true);
  }
};

export const extractAgentTitle = (id: string, titles: IAgentTitle[]) => {
  let value = titles.find((title) => title.id === id);
  return value;
};

export const extractZones = (id: string, zones: IZonesResponseObject[]) => {
  let value = zones.find((zone) => zone.zoneId === id);
  return value;
};

export const extractBrands = (brandId: string, brands: ISelectedBrand[]) => {
  return brands.find((brand) => brand.id === brandId);
};

const AddUpdateAgentManagementPage: React.FunctionComponent<
  IAddUpdateAgentManagementPageProps
> = (props: IAddUpdateAgentManagementPageProps) => {
  const ability = useContext(AbilityContext);
  const [agentManagement, setAgentManagementState] =
    useState<IAddUpdateAgentManagementPageState>({
      id: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.userId || ""
        : "",
      userId: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.userId || ""
        : "",
      email: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.email || ""
        : "",
      agentId: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.agentId || ""
        : "",
      agentName: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser?.name || ""
        : "",
      phoneNumber: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.phoneNumber || ""
        : "",
      nationalId: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.nationalId || ""
        : "",
      password: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.password || ""
        : autoGeneratePass,
      confirmPassword: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.confirmPassword || ""
        : autoGeneratePass,

      title: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.title
        : { id: "", label: "", value: "" },

      team: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.team
        : { id: "", label: "", value: "" },
      customerChannel: props.selectedAgentManagementUser?.customerChannel,
      zones: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.zones
        : [],
      brands: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.brands
        : [],
      status: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.status === "ACTIVE"
          ? true
          : false
        : false,
      resetPasswordModal: false,
      isAgentDetailsFound: false,
      createdByUser: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.createdByUser
        : "",
      createdAt: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.createdAt
        : "",
      updatedByUser: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.updatedByUser
        : "",
      updatedAt: props.selectedAgentManagementUser
        ? props.selectedAgentManagementUser.updatedAt
        : "",
    });
  const [allZones, setAllZones] = useState<IZonesResponseObject[]>(
    props.testClients || []
  );
  const [allBrands, setAllBrands] = useState<IBrandsResponseObject[]>(
    props.brands || []
  );

  const [selectedCity, setSelectedCity] = useState<any>(props.citiesList);
  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const [showPassword, setShowPassword] = useState(false);

  const createdAt = agentManagement.createdAt ? agentManagement.createdAt : "";
  const createdBy =
    props.bulkCustomerDetails &&
    props.bulkCustomerDetails[agentManagement.createdByUser]
      ? props.bulkCustomerDetails[agentManagement.createdByUser]?.fullName
      : "";
  const updatedAt = agentManagement.updatedAt ? agentManagement.updatedAt : "";
  const updatedBy = props.bulkCustomerDetails
    ? props.bulkCustomerDetails[agentManagement.updatedByUser]?.fullName
    : "";

  useEffect(() => {
    const { isEdit, searchText } = props;

    if (!isEdit) {
      const getUserDetails = async () => {
        let userDetails = await doUserAPIsearch(searchText);
        if (userDetails) {
          setAgentManagementState({
            ...agentManagement,
            userId: userDetails.id,
            agentName: userDetails.fullName,
            email: userDetails.email,
            nationalId: userDetails.nationalId,
            phoneNumber: userDetails.phoneNumber,
            isAgentDetailsFound: true,
          });
        }
      };
      getUserDetails();
    }
  }, []);

  useEffect(() => {
    const {
      getAllAgentZones,
      fetchAgentTitle,
      fetchAgentTeam,
      fetchCustomerConfig,
      fetchCities,
      fetchBrands,
    } = props;
    getAllAgentZones();
    fetchAgentTitle();
    fetchAgentTeam();
    fetchCustomerConfig();
    fetchCities();
    fetchBrands();
    if (isEdit) {
      //get agent details metadata
      const { getBulkCustomerDetailsByIdAction } = props;
      const userIds = [];
      if (agentManagement.id) userIds.push(agentManagement.id);
      if (agentManagement.createdByUser)
        userIds.push(agentManagement.createdByUser);
      if (agentManagement.updatedByUser)
        userIds.push(agentManagement.updatedByUser);
      if (userIds.length) getBulkCustomerDetailsByIdAction(userIds);
    }
  }, []);

  useEffect(() => {
    const { bulkCustomerDetails, isBulkCustomerDetailsFetched } = props;
    if (
      isEdit &&
      isBulkCustomerDetailsFetched &&
      bulkCustomerDetails &&
      bulkCustomerDetails[agentManagement.id]
    ) {
      setAgentManagementState({
        ...agentManagement,
        email: bulkCustomerDetails[agentManagement.id].email,
        nationalId:
          nationalId != null
            ? bulkCustomerDetails[agentManagement.id].nationalId
            : "",
      });
    }
  }, [props.isBulkCustomerDetailsFetched]);

  useEffect(() => {
    // get active zones / UCs
    const { getAllAgentZones } = props;
    if (selectedCity.id) {
      getAllAgentZones(selectedCity.id, customerChannel?.id);
    }
    handleSelectedCityChange(selectedCity);
  }, [selectedCity, agentManagement.customerChannel]);

  useEffect(() => {
    const { isAllAgentZonesFetched, allAgentZones } = props;
    if (isAllAgentZonesFetched && allAgentZones?.length) {
      setAllZones(allAgentZones);
    }
  }, [props.isAllAgentZonesFetched, props.allAgentZones]);

  useEffect(() => {
    const { brands } = props;
    if (brands && brands?.length) {
      setAllBrands(brands);

      const selectedBrands = agentManagement.brands.slice();
      selectedBrands?.map((brand, index) => {
        selectedBrands[index] = (brand.brandId &&
          extractBrands(brand.brandId, brands)) as ISelectedBrand;
      });

      if (selectedBrands) {
        setAgentManagementState({
          ...agentManagement,
          brands: selectedBrands.slice(),
        });
      }
    }
  }, [props.brands]);

  useEffect(() => {
    const {
      isAgentManagementUserAdded,
      isAgentManagementUserUpdated,
      backButtonHandler,
    } = props;
    if (isAgentManagementUserAdded || isAgentManagementUserUpdated)
      backButtonHandler(true);
  }, [props.isAgentManagementUserAdded, props.isAgentManagementUserUpdated]);

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      alert((error! as any).errors);
      handleToaster(true, (error! as any).errors);
    }
  }, [props.isError]);

  useEffect(() => {
    if (!selectedCity.id) {
      handleSlicedZoneWithCityId();
    }
  }, [props.isAllAgentZonesFetched, props.allAgentZones]);

  useEffect(() => {
    const { selectedAgentManagementUser, agentTeam } = props;
    if (selectedAgentManagementUser && agentTeam.length > 0) {
      const extractagentTeam = extractAgentTitle(
        selectedAgentManagementUser?.teamId as string,
        agentTeam as any
      );
      selectedAgentManagementUser.team = {
        id: extractagentTeam?.id as string,
        label: extractagentTeam?.label as string,
        value: extractagentTeam?.value as string,
      };
      const combObj = {
        ...agentManagement,
        team: { ...selectedAgentManagementUser.team },
      };
      setAgentManagementState(combObj);
    }
  }, [props.agentTeam]);

  useEffect(() => {
    const { selectedAgentManagementUser, agentTitle } = props;
    if (selectedAgentManagementUser && agentTitle.length > 0) {
      const extractagentTeam = extractAgentTitle(
        selectedAgentManagementUser?.titleId as string,
        agentTitle as any
      );
      if (extractagentTeam) {
        selectedAgentManagementUser.title = {
          id: extractagentTeam?.id as string,
          label: extractagentTeam?.label as string,
          value: extractagentTeam?.value as string,
        };
        const combObj = {
          ...agentManagement,
          title: { ...selectedAgentManagementUser.title },
        };
        setAgentManagementState(combObj);
      }
    }
  }, [props.agentTitle]);

  const handleSlicedZoneWithCityId = () => {
    const {
      allAgentZones,
      isAllAgentZonesFetched,
      selectedAgentManagementUser,
    } = props;
    if (
      isAllAgentZonesFetched &&
      allAgentZones &&
      allAgentZones?.length > 0
      // selectedAgentManagementUser.status == "ACTIVE" &&
      // selectedAgentManagementUser?.accountStatus === "ACTIVE"
    ) {
      const sliceZone = agentManagement.zones.slice();
      sliceZone?.map((zone, index) => {
        const zoneIdMatched = allAgentZones.findIndex((i) => {
          return i.id === zone.zoneId;
        });
        sliceZone[index] = allAgentZones && allAgentZones[zoneIdMatched];
      });

      //for handling inactive ucs
      if (sliceZone) {
        setAgentManagementState({
          ...agentManagement,
          zones: sliceZone.slice(),
        });
      }
    }
  };

  const handleSubmit = (e: any) => {
    const {
      createAgentTitleTeamZone,
      isEdit,
      updateAgentTitleTeamZone,
      createAgentTeamZone,
    } = props;

    if (isEdit) {
      updateAgentTitleTeamZone(
        normalizeAgentManagementUserUpdatePayload(agentManagement)
      );
    } else if (agentManagement.isAgentDetailsFound) {
      createAgentTeamZone(normalizeCreateAgentOnlyPayload(agentManagement));
    } else {
      createAgentTitleTeamZone(
        normalizeAgentManagementUserCreatePayload(agentManagement)
      );
    }
  };

  const resetPassword = () => {
    let { selectedAgentManagementUser, isEdit, backButtonHandler } = props;
    let userId: any =
      selectedAgentManagementUser && selectedAgentManagementUser.userId;
    let passwordPayload = {
      password: autoGeneratePass,
      passwordConfirmation: autoGeneratePass,
    };
    if (isEdit && (updateUserPasswordApiCall(userId, passwordPayload) as any)) {
      resetPasswordConfirmationModal();
      backButtonHandler(true, "passwordResetSuccess");
    } else {
      backButtonHandler(false, "passwordResetUnsuccessful");
    }
  };

  const resetPasswordConfirmationModal = () => {
    setAgentManagementState({
      ...agentManagement,
      resetPasswordModal: !agentManagement.resetPasswordModal,
    });
  };

  const handleChange = (e: any) => {
    const fieldId: string = e.target.id;
    const fieldValue: string = e.target.value;
    setAgentManagementState({
      ...agentManagement,
      [fieldId]: fieldValue,
    });
  };

  const handleZoneChange = (e: any) => {
    const agentZones = agentManagement;
    agentZones.zones = e.slice();
    setAgentManagementState({
      ...agentZones,
    });
  };

  const handleBrandChange = (e: any) => {
    const agentBrands = agentManagement;
    agentBrands.brands = e.slice();
    setAgentManagementState({
      ...agentBrands,
    });
  };

  const handleCnic = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (numbersOnly(e.target.value)) {
      //Adding check for optional field
      if (
        (nationalId &&
          e.target.value.length > agentManagement.nationalId?.length) ||
        Math.abs(e.target.value.length - agentManagement.nationalId.length) > 1
      ) {
        const formattedCnic = formatnationalId(
          e.target.value.replace(/-/g, "")
        );
        agentManagement.nationalId = formattedCnic;
      } else {
        agentManagement.nationalId = e.target.value;
      }
      setAgentManagementState({ ...agentManagement });
    }
  };

  const formatnationalId = (str: string) => {
    if (str.length >= 5) {
      if (str.length >= 12) {
        let firstPart = str.substring(0, 5);
        let secondPart = str.substring(5, str.length);
        firstPart += "-";
        let newFinal = firstPart + secondPart;
        firstPart = newFinal.substring(0, 13);
        firstPart += "-";
        secondPart = newFinal.substring(13, newFinal.length);
        return firstPart + secondPart;
      } else {
        let firstPart = str.substring(0, 5);
        let secondPart = str.substring(5, str.length);
        firstPart += "-";
        return firstPart + secondPart;
      }
    }
    return str;
  };

  const handleGoBackButton = () => {
    const { backButtonHandler, clearBulkCustomerDetailsAction } = props;
    backButtonHandler(false);
    clearBulkCustomerDetailsAction();
  };

  const {
    agentName,
    phoneNumber,
    email,
    password,
    confirmPassword,
    nationalId,
    title,
    team,
    customerChannel,
    zones,
    brands,
  } = agentManagement;
  if (agentManagement.nationalId == null) {
    setAgentManagementState({
      ...agentManagement,
      nationalId: "",
    });
  }
  const validateForm =
    agentName.length > 0 &&
    phoneNumber.length > 0 &&
    password === confirmPassword &&
    team &&
    customerChannel &&
    team.id !== "" &&
    nationalId?.length === 15;

  const { isEdit, isLoading, selectedAgentManagementUser } = props;

  const isPasswordDisabled = isEdit ? false : true;

  const buttonText = isEdit ? "Update details" : "Create agent";

  const headingText = isEdit
    ? (selectedAgentManagementUser?.agentName as string)
    : "Add agent";

  const isPhoneNumberDisabled = isEdit ? true : false;

  const handleDeactivateAccount = () => {
    setAgentManagementState({
      ...agentManagement,
      status: !status,
    });
  };

  const handleSearchableSelect = (e: any, id: string) => {
    setAgentManagementState({
      ...agentManagement,
      [id]: e,
    });
  };

  const handleSelectedCityChange = (e: IIdValuePairResponse[]) => {
    setSelectedCity(e);
  };

  const renderBrandDetails = () => {
    if (
      title &&
      (title === PRIME_AGENT || (title as ISelectedBrand).id === PRIME_AGENT)
    ) {
      return (
        <div id="multi-select-brand">
          {" "}
          <MultiSelectDropDown
            options={allBrands}
            label="Brands"
            selectedValues={brands}
            placeholder="Please select brands which apply"
            displayValue="label"
            onChange={handleBrandChange}
            onRemove={handleBrandChange}
          />
        </div>
      );
    } else {
      agentManagement.brands = [];
    }
  };

  const renderTeamDetailsSection = () => {
    const { selectedAgentManagementUser, userInfo } = props;

    let allowAccess = false;
    if (userInfo.id === selectedAgentManagementUser?.agentId) {
      allowAccess = ability.can(
        "*",
        new access({ userId: selectedAgentManagementUser?.agentId })
      );
    } else {
      allowAccess = ability.can("*", "agent");
    }

    const updateAccess = ability.can("*", "agent");
    const createAccess =
      ability.can("update", "agent") ||
      ability.can("*", "agent") ||
      ability.can("read", "agent");

    if (createAccess) {
      return (
        <FormSectionLayout subTitleText="Team details">
          <SearchableSelect
            id="title"
            isSearchable={true}
            options={props.agentTitle}
            onChange={(e: any) => {
              handleSearchableSelect(e, "title");
            }}
            label="Title"
            placeholder="Select agent title"
            selectedValue={title}
          />
          <SearchableSelect
            id="team"
            isSearchable={true}
            options={props.agentTeam}
            onChange={(e: any) => {
              handleSearchableSelect(e, "team");
            }}
            label="Team"
            placeholder="Select agent team"
            selectedValue={team}
          />
          <SearchableSelect
            id="customerChannel"
            isSearchable={true}
            options={
              props.customerConfig ? props.customerConfig.customerChannels : []
            }
            onChange={(e: any) => {
              handleSearchableSelect(e, "customerChannel");
            }}
            label="Customer Channel"
            placeholder="Select customer channel"
            selectedValue={customerChannel}
          />
          <SearchableSelect
            id="city"
            label="city"
            isSearchable={true}
            options={props.citiesList}
            onChange={handleSelectedCityChange}
          />
          <MultiSelectDropDown
            options={selectedCity.id && allZones}
            label="Neighbourhood"
            selectedValues={zones}
            placeholder="Please select platforms which apply"
            displayValue="name"
            onChange={handleZoneChange}
            onRemove={handleZoneChange}
          />
          {renderBrandDetails()}
        </FormSectionLayout>
      );
    }
  };

  const { status, resetPasswordModal } = agentManagement;
  const isActivate = status ? "Deactivate" : "Activate";

  const agentsMoreActions = [
    {
      id: 1,
      buttonName: isActivate,
      clickHandler: handleDeactivateAccount,
    },
  ];

  const trimSpace = (fullName: string) => {
    if (fullName.substring(1) === " ") {
      return (fullName = fullName.substring(1));
    } else {
      return fullName;
    }
  };

  return (
    <div>
      <Modal
        showModal={resetPasswordModal}
        closeModalHandler={resetPasswordConfirmationModal}
        modalHeading="Change password"
        showProgressString={false}
        failedRecords=""
        modalBodyClass="verify-account"
      >
        {
          <>
            <p>Are you sure you want to change the password?</p>
            <Row>
              <Col className="col-lg-5">
                <ButtonComponent
                  buttonClass="button-full btn btn-primary-outline"
                  buttonText="Go back"
                  onClickHandler={resetPasswordConfirmationModal}
                />
              </Col>
              <Col className="col-lg-7 no-padding-left">
                <ButtonComponent
                  buttonClass="button-full btn btn-primary"
                  buttonText="Change Password"
                  onClickHandler={resetPassword}
                />
              </Col>
            </Row>
          </>
        }
      </Modal>
      {isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <Toaster
        showToaster={showPassword}
        toasterClass="toaster toaster-bg-success"
      >
        Password Copied
      </Toaster>
      <Container fluid>
        <Row>
          <Col lg="5">
            <div className="back-button">
              <a href="javascript:void(0)" onClick={handleGoBackButton}>
                <span>
                  <img src={backArrowIcon} alt="close" />
                </span>{" "}
                Back to Users
              </a>
            </div>
            <HeadingText text={headingText} isMainHeading={true} />
          </Col>
          <Col lg="5">
            {agentManagement && (
              <LoggingViewer
                createdAt={createdAt}
                createdBy={createdBy}
                updatedAt={updatedAt}
                updatedBy={updatedBy}
              />
            )}
          </Col>
        </Row>
        <Row className="form-container">
          <Col xs="12">
            <Form name="access-control-add-update-form">
              <div className="account-detail">
                <FormSectionLayout subTitleText="Account details">
                  <TextField
                    id="agentName"
                    label="Full Name"
                    placeholder="e.g. Bill Gates"
                    value={trimSpace(agentName)}
                    handleChange={handleChange}
                    error={alphaNumericValidator(agentName)}
                  />
                  <TextField
                    id="phoneNumber"
                    label="Phone Number"
                    placeholder="e.g. 03421231231"
                    value={phoneNumber.trim()}
                    handleChange={handleChange}
                    validator={phoneNumberValidate}
                    error={phoneNumberOnlyValidator(phoneNumber)}
                    disabled={isPhoneNumberDisabled}
                  />
                  <TextField
                    id="email"
                    label="Email"
                    placeholder="e.g. abc@yourdomain.com"
                    value={email.trim()}
                    handleChange={handleChange}
                    isOptional={true}
                  />
                  <TextField
                    id="nationalId"
                    label="CNIC Number"
                    placeholder="e.g. 11111-1111111-1"
                    value={nationalId ? nationalId.trim() : nationalId}
                    handleChange={handleCnic}
                    validator={cnicNumberValidate}
                    maxLength={15}
                    error={
                      nationalId ? cnicNumberOnlyValidator(nationalId) : ""
                    }
                  />
                  <div className={isEdit ? "form-row" : ""}>
                    <Col>
                      {isEdit && (
                        <ButtonComponent
                          buttonClass="btn btn-primary-outline button-large reset-button"
                          buttonText="Reset password"
                          onClickHandler={resetPasswordConfirmationModal}
                        />
                      )}
                    </Col>
                  </div>
                </FormSectionLayout>
                <div id="team-details">{renderTeamDetailsSection()}</div>
              </div>
              <div className="form-row-separator">
                <FormSectionLayout subTitleText="">
                  <div className="form-row-separator">
                    <Row id="addEditButtonRow">
                      {(ability.can("update", "user") ||
                        ability.can("create", "user")) && (
                        <ButtonComponent
                          buttonClass="large-button btn-primary ml-3"
                          buttonText={buttonText}
                          onClickHandler={handleSubmit}
                          isDisable={props.isLoading || !validateForm}
                        />
                      )}

                      {isEdit && ability.can("update", "user") && (
                        <Col lg="5">
                          <DropdownButton
                            classNames="dropdown more-actions deactivate-account"
                            dropDownButtonText="More actions"
                            dropdownItem={agentsMoreActions}
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                </FormSectionLayout>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddUpdateAgentManagementPage;
